import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiFilter, FiDownload, FiFileText, FiColumns } from 'react-icons/fi';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Button } from '../../../../../../../app/components/Button';
import Table from '../../../../../../../app/components/Table';
import StaggeredColumnSelector from '../../../../../../../app/components/ColumnSelector';
import { usePageTitle } from '../../../../../../../contexts/PageTitleContext';


export default function NewReport() {
  const navigate = useNavigate();
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle('Novo Relatório');
  }, [setTitle]);

  const colunasPadrao = ['Código', 'Título', 'Fase', 'Responsável'];

  const [tituloDoRelatorio, definirTituloDoRelatorio] = useState('');
  const [colunasVisiveis, definirColunasVisiveis] = useState(() =>
    Object.fromEntries(colunasPadrao.map(coluna => [coluna, true]))
  );

  const [mapaDeColunasParaCampos, definirMapaDeColunasParaCampos] = useState(() => ({
    'Código': 'codigo',
    'Título': 'titulo',
    'Fase': 'fase',
    'Responsável': 'responsavel',
  }));

  const lidarComAplicacaoDeColunas = (colunasSelecionadas, mapa) => {
    definirColunasVisiveis(colunasSelecionadas);
    definirMapaDeColunasParaCampos(mapa);
  };

  const colunasFormatadas = Object.entries(colunasVisiveis)
    .filter(([_, visivel]) => visivel)
    .map(([coluna]) => ({
      campo: mapaDeColunasParaCampos[coluna] || coluna.toLowerCase().replace(/\s+/g, '_'),
      titulo: coluna,
      align: 'left',
    }));

  const dadosDaTabela = [
    {
      codigo: 4,
      titulo: 'PROJEZI ARQUITETURA E ENGENHARIA',
      fase: 'Contrato Assinado',
      responsavel: 'Barbara Lima',
    },
    {
      codigo: 5,
      titulo: 'ALPHA CONSULTORIA LTDA',
      fase: 'Negociação',
      responsavel: 'Carlos Silva',
    },
    {
      codigo: 6,
      titulo: 'BETA SOLUÇÕES EIRELI',
      fase: 'Perdido',
      responsavel: 'Fernanda Rocha',
    },
  ];

  const dadosCompletos = dadosDaTabela.map((item) => {
    const novoItem = { ...item };
    Object.values(mapaDeColunasParaCampos).forEach((campo) => {
      if (!(campo in novoItem)) {
        novoItem[campo] = '';
      }
    });
    return novoItem;
  });

  const lidarComSalvarRelatorio = () => {
    const relatoriosExistentes = JSON.parse(localStorage.getItem('relatorios')) || [];
  
    const novoRelatorio = {
      id: Date.now(),
      titulo: tituloDoRelatorio || `Relatório ${relatoriosExistentes.length + 1}`,
      dataCriacao: new Date().toLocaleString('pt-BR'),
      dataAtualizacao: new Date().toLocaleString('pt-BR')
    };
  
    localStorage.setItem('relatorios', JSON.stringify([...relatoriosExistentes, novoRelatorio]));
  
    navigate('/detalhes-sequencia?tab=Documentos');
  };
  
  const lidarComExportarRelatorio = () => {
    const doc = new jsPDF();
    const colunas = colunasFormatadas.map(col => col.titulo);
    const linhas = dadosCompletos.map(linha =>
      colunas.map(titulo => {
        const campo = mapaDeColunasParaCampos[titulo];
        return linha[campo];
      })
    );
    autoTable(doc, {
      head: [colunas],
      body: linhas,
    });
    doc.save('relatorio.pdf');
  };

  const lidarComFiltrarDados = () => {
    console.log('Filtrando dados');
  };

  const lidarComCliqueNaLinha = (linha) => {
    console.log('Linha clicada:', linha);
  };

  useEffect(() => {
    definirTituloDoRelatorio('Relatório Comercial');
  }, []);

  return (
    <div>
      <div className="min-h-screen">
        <div className="max-w-full mx-auto p-4">
          <div className="flex flex-wrap gap-2 mb-4">
            <Button
              variant="secondary"
              onClick={lidarComSalvarRelatorio}
              icon={<FiFileText size={16} />}
              className="w-8 h-8 p-0 flex items-center justify-center"
            />
            <Button
              variant="secondary"
              onClick={lidarComFiltrarDados}
              icon={<FiFilter size={16} />}
              className="w-8 h-8 p-0 flex items-center justify-center"
            />
            <StaggeredColumnSelector
              onApplyColumns={lidarComAplicacaoDeColunas}
              defaultIcon={<FiColumns size={16} />}
            />
            <Button
              variant="secondary"
              onClick={lidarComExportarRelatorio}
              icon={<FiDownload size={16} />}
              className="w-8 h-8 p-0 flex items-center justify-center"
            />
          </div>

          <div className="w-full overflow-x-auto">
            <div className="min-w-max">
              <Table
                colunas={colunasFormatadas}
                dados={dadosCompletos}
                onRowClick={lidarComCliqueNaLinha}
                renderizarStatus={(status) => {
                  const estilosDeStatus = {
                    'Contrato Assinado': 'bg-green-100 text-green-800',
                    'Negociação': 'bg-blue-100 text-blue-800',
                    'Perdido': 'bg-red-100 text-red-800',
                  };
                  return (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${estilosDeStatus[status] || 'bg-gray-100 text-gray-800'}`}>
                      {status}
                    </span>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
